import { c as _c } from "react/compiler-runtime";
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { CampaignStepActivateData, CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useActivateCampaignStep = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      fetcherActivateCampaignStep: async (id, data) => {
        ;
        try {
          await fetcher(`${CAMPAIGNS_API}/activate/steps/${id}`, data);
        } catch (t2) {
          const e = t2;
          throw e;
        }
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};